import ModelsNew from "./[id]";

export default ModelsNew;
